export const sortData = ({ data, column, type, sortType }) => {
  if (!data || !column || !sortType) return data;

  return [...data].sort((a, b) => {
    const valA = a[column];
    const valB = b[column];

    if (type === "number") {
      return sortType === "asc"
        ? (valA || 0) - (valB || 0)
        : (valB || 0) - (valA || 0);
    }

    if (type === "string") {
      return sortType === "asc"
        ? (valA ?? "")?.localeCompare(valB ?? "")
        : (valB ?? "")?.localeCompare(valA ?? "");
    }

    if (type === "date") {
      return sortType === "asc"
        ? new Date(valA) - new Date(valB)
        : new Date(valB) - new Date(valA);
    }

    return 0; // Default case
  });
};

// utils/customSort.js

export function customGroupSort(data, sortColumn, sortType) {
  // Determine whether the field to sort on is numeric or a string.
  const isNumeric =
    typeof data.find((item) => item[sortColumn])?.[sortColumn] === "number";

  // Separate the "Total" row from the rest
  const filteredData = data.filter((item) => item.name !== "Total");
  const totalRow = data.find((item) => item.name === "Total");

  // Sort the non-total rows
  const sortedData = filteredData.sort((a, b) => {
    const aVal = a[sortColumn] || 0;
    const bVal = b[sortColumn] || 0;
    if (isNumeric) {
      return sortType === "asc" ? aVal - bVal : bVal - aVal;
    } else {
      // For strings use localeCompare
      return sortType === "asc"
        ? String(aVal ?? "").localeCompare(String(bVal ?? ""))
        : String(bVal ?? "").localeCompare(String(aVal ?? ""));
    }
  });

  // Append the total row at the bottom if it exists
  if (totalRow) {
    sortedData.push(totalRow);
  }
  return sortedData;
}
